export default {
  isAuthorized(state) {
    return !!state.user?.user_id
  },
  isSub(state) {
    if (!state?.accountID) return false
    if (!state.user?.user_id) return false
    return state?.accountID !== state.user?.user_id
  },
  accountID: (state) => state.accountID,
  isSuspended(state) {
    return !!state.user.suspended
  },
  preferredFiat: (state) => state?.profile?.preferred_currency || 'usd',
  preferredCrypto: (state) => state?.preferred_crypto || 'btc',
  isDonation: (state) => !!state?.profile?.donation,
  analyticsUserId: (state) => state?.profile?.segment_id,
  isPhoneEnabled(state){
    return state?.secure?.is_phone_verified && state?.secure?.phone
  },
  isTwoFaGoogle(state){
    return state?.secure?.is_2fa_google_enabled
  },
  isTwoFaPhone(state){
    return state?.secure?.is_2fa_mobile_enabled
  },
  twoFaMethod(state){
    if(state?.secure?.is_2fa_google_enabled) {
      return 'google'
    }

    if(state?.secure?.is_phone_verified) {
      return 'phone'
    }

    return null;
  },
  accounts(state) {
    const sub = state.sub;
    const customer = state.customer;

    const list = [customer, ...Object.values(sub)];

    return list.map(({ identifier }) => ({
      text: identifier.username,
      value: identifier.id,
    }));
  },
};
